export const SOCIAL_CARDS = [
  {
    description:
      'Bulletproof focus formula: <br /> <br /> Pomodorro timer + Noise-cancelling headphones with <span>@brainfmapp</span> on + Notifications off + At least 20 min cardio in the morning = Any task is done 3 times faster',
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-alex-popova.png',
    username: '@alex_popova',
    name: 'Alex Popova',
  },
  {
    description: `I've just discovered <span>@brainfmapp</span> <br /> <br /> It's a literal cure for my ADHD. <br /> <br /> Just came out of a 4.5hr deep work session. <br /> <br />Truly am amazed, usually can't concentrate for longer than 30mins. <br /> <br />Game changer`,
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-ben-simpson.png',
    username: '@bensimpsonau',
    name: 'Ben Simpson',
  },
  {
    description: `<span>@BrainfmApp</span> = Zen Work Mode`,
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-akaash-joshi.png',
    username: '@scaleegod',
    name: 'Akaash Joshi',
  },
  {
    description: `Listening to <span>@BrainfmApp</span> <br/>supercharges my productivity. It helps me going into a deep flow state whenever I want. You heard right: whenever I want.`,
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-nico.png',
    username: '@nicotfl',
    name: 'Nico',
  },
  {
    description: `<span>@brainfmapp</span> has been a great ally to my productivity in the last couple of years as a Software Developer. <br/><br/>As a Ghostwriter, it 10x my productivity without a doubt. <br/> <br/> Try it!`,
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-romulo-alves.png',
    username: '@romuloaalves',
    name: 'Rômulo Alves',
  },
  {
    description: `Honestly what's really great for me when working/deep focus task - especially as someone with ADHD is <span>@BrainfmApp</span>.`,
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-robot-bear.png',
    username: '@iamrobotbear',
    name: 'robotbear.eth',
  },
  {
    description: `I’m obsessed with increasing focus and getting productivity gains. I must say Brain.fm is worth every penny I have paid for it. Flow state instantly activated.`,
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-dappadan.png',
    name: 'Dappadan',
  },
  {
    description: `I’m an adult with ADHD. I’ve seen a huge difference in my ability to focus when I listen to the highest neural effect setting with my noise-canceling headphones. I’m so glad this app exists! ❤️`,
    profileImageUrl: 'https://cdn.brain.fm/images/adhd/social-morri-b.png',
    name: 'Morri B.',
  },
];
